import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'kng-content',
  templateUrl: './kng-content.component.html',
  styleUrls: []
})
export class KngContent implements OnInit {

  @Input('additional-classes')
  public additionalClasses: string = '';

  @ViewChild("contentElement", {read: ElementRef})
  contentElement: ElementRef;

  @Output() onScroll: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    if( this.onScroll ) {
      this.contentElement.nativeElement.onscroll = () => {
        this.onScroll.emit(this.contentElement.nativeElement.scrollTop);
      }
    }
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/kng-content/kng-content.component.ts